import { render } from "./CIS-Content-Blue-Box.vue?vue&type=template&id=4195c51f&scoped=true"
import script from "./CIS-Content-Blue-Box.vue?vue&type=script&lang=js"
export * from "./CIS-Content-Blue-Box.vue?vue&type=script&lang=js"

import "./CIS-Content-Blue-Box.vue?vue&type=style&index=0&id=4195c51f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4195c51f"]])

export default __exports__